// React Required
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

// Create Import File
import './mode.sass';
import './index.scss';
import './override.sass';

import PageScrollTop from './component/PageScrollTop';

// Tiger Sheep
import Home from './tigersheep/Home';
import TSMainDemo from './tigersheep/MainDemo';
import TSDarkMainDemo from './tigersheep/MainDemo-Dark';
import TSPlaceholder from './tigersheep/pages/Placeholder';
import TSAboutUs from './tigersheep/pages/AboutUs';
import TSBlog from './tigersheep/pages/Blog';
import TSCareers from './tigersheep/pages/Careers';
import TSContact from './tigersheep/pages/Contact';
import TSOurWork from './tigersheep/pages/OurWork';
import TSServices from './tigersheep/pages/Services';
import TSWhatWeDo from './tigersheep/pages/WhatWeDo';
import './mode';

// Home layout
import Demo from './page-demo/Demo';
import MainDemo from './home/MainDemo';
import Startup from './home/Startup';
import Paralax from './home/Paralax';
import HomePortfolio from './home/HomePortfolio';
import DigitalAgency from './home/DigitalAgency';
import CreativeAgency from './home/CreativeAgency';
import PersonalPortfolio from './home/PersonalPortfolio';
import Business from './home/Business';
import StudioAgency from './home/StudioAgency';
import PortfolioLanding from './home/PortfolioLanding';
import CreativeLanding from './home/CreativeLanding';
import HomeParticles from './home/HomeParticles';
import CreativePortfolio from './home/CreativePortfolio';
import DesignerPortfolio from './home/DesignerPortfolio';
import InteriorLanding from './home/Interior';
import CorporateBusiness from './home/CorporateBusiness';
import InteractiveAgency from './home/InteractiveAgency';

// Dark Home Layout 
import DarkMainDemo from './dark/MainDemo';
import DarkPortfolioLanding from './dark/PortfolioLanding';

// Element Layout
import Service from "./elements/Service";
import ServiceDetails from "./elements/ServiceDetails";
import About from "./elements/About";
import ContactPage from "./elements/Contact";
import PortfolioDetails from "./elements/PortfolioDetails";
import Blog from "./elements/Blog";
import BlogDetails from "./elements/BlogDetails";
import error404 from "./elements/error404";


// Blocks Layout

import Team from "./blocks/Team";
import Counters from "./blocks/Counters";
import Testimonial from "./blocks/Testimonial";
import Portfolio from "./blocks/Portfolio";
import VideoPopup from "./blocks/VideoPopup";
import Gallery from "./blocks/Gallery";
import Brand from "./blocks/Brand";
import ProgressBar from "./blocks/ProgressBar";
import ContactForm from "./blocks/ContactForm";
import GoogleMap from "./blocks/GoogleMap";
import Columns from "./blocks/Columns";
import PricingTable from "./blocks/PricingTable";
import { Router, HashRouter, BrowserRouter, Switch, Route  } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import * as serviceWorker from './serviceWorker';

const basename = document.querySelector('base')?.getAttribute('href') ?? '/' 

class Root extends Component{
    render(){
        return(
            <BrowserRouter basename={basename}>
            {/* <BrowserRouter basename={basename}> */}
                <PageScrollTop>
                    <Switch>
					
						{/* Tiger Sheep */}
                        <Route exact path={`/`} component={TSMainDemo}/>
						<Route exact path={`/tshome`} component={TSMainDemo}/>
						//removed actual dark test page for clarity
                        <Route exact path={`/tshome-dark`} component={TSMainDemo}/>
                        <Route exact path={`/placeholder`} component={TSPlaceholder}/>
                        <Route exact path={`/aboutus`} component={TSAboutUs}/>
                        <Route exact path={`/tsblog`} component={TSBlog}/>
                        <Route exact path={`/careers`} component={TSCareers}/>
                        <Route exact path={`/contact`} component={TSContact}/>
                        <Route exact path={`/ourwork`} component={TSOurWork}/>
                        <Route exact path={`/services`} component={TSServices}/>
                        <Route exact path={`/whatwedo`} component={TSWhatWeDo}/>
				
				
				import Home from './tigersheep/Home';
				import TSMainDemo from './tigersheep/MainDemo';
				import TSDarkMainDemo from './tigersheep/MainDemo-Dark';
				import TSPlaceholder from './tigersheep/pages/Placeholder';
				import TSAboutUs from './tigersheep/pages/AboutUs';
				import TSBlog from './tigersheep/pages/Blog';
				import TSCareers from './tigersheep/pages/Careers';
				import TSContact from './tigersheep/pages/Contact';
				import TSOurWork from './tigersheep/pages/OurWork';
				import TSServices from './tigersheep/pages/Services';
				import TSWhatWeDo from './tigersheep/pages/WhatWeDo';
				
				
						{/* Demo */}
                        <Route exact path={`/demo`} component={Demo}/>
						<Route exact path={`/main-demo`} component={MainDemo}/>
                        <Route exact path={`/dark-main-demo`} component={DarkMainDemo}/>
                        <Route exact path={`/startup`} component={Startup}/>
                        <Route exact path={`/paralax`} component={Paralax}/>

                        <Route exact path={`/digital-agency`} component={DigitalAgency}/>
                        <Route exact path={`/creative-agency`} component={CreativeAgency}/>
                        <Route exact path={`/personal-portfolio`} component={PersonalPortfolio}/>
                        <Route exact path={`/studio-agency`} component={StudioAgency}/>
                        <Route exact path={`/business`} component={Business}/>
                        <Route exact path={`/portfolio-home`} component={HomePortfolio}/>
                        <Route exact path={`/portfolio-landing`} component={PortfolioLanding}/>
                        <Route exact path={`/creative-landing`} component={CreativeLanding}/>
                        <Route exact path={`/home-particles`} component={HomeParticles}/>
                        <Route exact path={`/dark-portfolio-landing`} component={DarkPortfolioLanding}/>
                        <Route exact path={`/designer-portfolio`} component={DesignerPortfolio}/>
                        <Route exact path={`/creative-portfolio`} component={CreativePortfolio}/>
                        <Route exact path={`/interior-landing`} component={InteriorLanding}/>
                        <Route exact path={`/corporate-business`} component={CorporateBusiness}/>
                        <Route exact path={`/interactive-agency`} component={InteractiveAgency}/>

                        {/* Element Layot */}
                        <Route exact path={`/service`} component={Service}/>
                        <Route exact path={`/service-details`} component={ServiceDetails}/>
                        <Route exact path={`/contactpage`} component={ContactPage}/>
                        <Route exact path={`/about`} component={About}/>
                        <Route exact path={`/portfolio-details`} component={PortfolioDetails}/>
                        <Route exact path={`/blog`} component={Blog}/>
                        <Route exact path={`/blog-details`} component={BlogDetails}/>

                        {/* Blocks Elements  */}
                        <Route exact path={`/team`} component={Team}/>
                        <Route exact path={`/counters`} component={Counters}/>
                        <Route exact path={`/testimonial`} component={Testimonial}/>
                        <Route exact path={`/portfolio`} component={Portfolio}/>
                        <Route exact path={`/video-popup`} component={VideoPopup}/>
                        <Route exact path={`/gallery`} component={Gallery}/>
                        <Route exact path={`/clint-logo`} component={Brand}/>
                        <Route exact path={`/progressbar`} component={ProgressBar}/>
                        <Route exact path={`/contact-form`} component={ContactForm}/>
                        <Route exact path={`/google-map`} component={GoogleMap}/>
                        <Route exact path={`/columns`} component={Columns}/>
                        <Route exact path={`/pricing-table`} component={PricingTable}/>


                        
                        <Route path={`/404`} component={error404}/>
                        <Route component={error404}/>

                    </Switch>
                </PageScrollTop>
            </BrowserRouter>
        )
    }
}

ReactDOM.render(<Root/>, document.getElementById('root'));
serviceWorker.register();